import React from 'react';
import { Trash2 } from 'lucide-react';
import { Dialog } from '../../components/ui/Dialog';
import { Button } from '../../components/ui/Button';
import { t } from '../../lib/i18n';

/** Çöp kutusundaki toplantı bu kadar gün sonra kalıcı silinir (sunucu: web/lib/jobs/purge.ts). */
export const TRASH_RETENTION_DAYS = 30;

interface DeleteMeetingDialogProps {
  open: boolean;
  /** Silinecek toplantının başlığı; birden fazlaysa sayısı. */
  title?: string;
  count?: number;
  /** Toplantıda çalışan ya da planlanmış bir bot var — çıkarılacağını söyle. */
  hasActiveBot?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * "Sil" onayı: toplantı kalıcı silinmiyor, çöp kutusuna gidiyor. Metin bunu
 * açıkça söylüyor ki kullanıcı neyin geri alınabildiğini bilsin.
 */
export const DeleteMeetingDialog: React.FC<DeleteMeetingDialogProps> = ({
  open,
  title,
  count = 1,
  hasActiveBot = false,
  onCancel,
  onConfirm,
}) => (
  <Dialog
    open={open}
    onClose={onCancel}
    title={count > 1 ? t(`${count} toplantı silinsin mi?`, `Delete ${count} meetings?`) : t('Toplantı silinsin mi?', 'Delete this meeting?')}
    className="max-w-md"
    footer={
      <>
        <Button variant="ghost" onClick={onCancel}>
          {t('Vazgeç', 'Cancel')}
        </Button>
        <Button
          autoFocus
          onClick={onConfirm}
          className="bg-rose-600 text-white hover:bg-rose-500"
        >
          <Trash2 className="size-4" />
          {t('Çöp kutusuna taşı', 'Move to trash')}
        </Button>
      </>
    }
  >
    <div className="space-y-3 text-sm leading-relaxed">
      {title && count === 1 && <p className="font-medium break-words">“{title}”</p>}
      <p className="text-muted-foreground">
        {t(
          `Çöp kutusuna taşınacak. ${TRASH_RETENTION_DAYS} gün içinde oradan geri alabilirsin; sonra kaydı, transkripti ve notlarıyla birlikte kalıcı olarak silinir.`,
          `It will be moved to the trash. You can restore it from there within ${TRASH_RETENTION_DAYS} days; after that it’s permanently deleted with its recording, transcript and notes.`
        )}
      </p>
      {hasActiveBot && (
        <p className="text-amber-500">
          {t(
            'Bu toplantıda çalışan ya da planlanmış bir bot var; toplantıdan çıkarılacak.',
            'A bot is running or scheduled for this meeting; it will be removed.'
          )}
        </p>
      )}
    </div>
  </Dialog>
);
